import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useMemo, useEffect, useContext } from 'react';
import clsx from 'clsx';
import { isDef, addUnit } from '../utils';
import Icon from '../icon';
import { useSetState } from '../hooks';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var Image = function Image(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('image', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var _useSetState = useSetState({
    loading: true,
    error: false
  }),
      _useSetState2 = _slicedToArray(_useSetState, 2),
      status = _useSetState2[0],
      setStatus = _useSetState2[1];

  var imgRef = useRef(null);
  var fit = props.fit,
      errorIcon = props.errorIcon,
      loadingIcon = props.loadingIcon,
      showError = props.showError,
      showLoading = props.showLoading,
      block = props.block;
  var style = useMemo(function () {
    var internalStyle = _objectSpread({}, props.style);

    if (isDef(props.width)) {
      internalStyle.width = addUnit(props.width);
    }

    if (isDef(props.height)) {
      internalStyle.height = addUnit(props.height);
    }

    if (isDef(props.radius)) {
      internalStyle.overflow = 'hidden';
      internalStyle.borderRadius = addUnit(props.radius);
    }

    return internalStyle;
  }, [props.style]);
  useEffect(function () {
    var payload = {
      error: false,
      loading: true
    };

    if (imgRef.current) {
      if (imgRef.current.complete) {
        payload.loading = false;
      } else {
        payload.loading = true;
      }
    }

    setStatus(payload);
  }, [props.src]);

  var onLoad = function onLoad(e) {
    var _props$onLoad;

    setStatus({
      loading: false
    });
    (_props$onLoad = props.onLoad) === null || _props$onLoad === void 0 ? void 0 : _props$onLoad.call(props, e);
  };

  var onError = function onError(e) {
    var _props$onLoad2;

    setStatus({
      error: true,
      loading: false
    });
    (_props$onLoad2 = props.onLoad) === null || _props$onLoad2 === void 0 ? void 0 : _props$onLoad2.call(props, e);
  };

  var renderLoadingIcon = function renderLoadingIcon() {
    if (typeof loadingIcon !== 'string') return loadingIcon;
    return /*#__PURE__*/React.createElement(Icon, {
      size: props.iconSize,
      name: loadingIcon,
      className: clsx(bem('loading-icon')),
      classPrefix: props.iconPrefix
    });
  };

  var renderErrorIcon = function renderErrorIcon() {
    if (typeof errorIcon !== 'string') return errorIcon;
    return /*#__PURE__*/React.createElement(Icon, {
      size: props.iconSize,
      name: errorIcon,
      className: clsx(bem('error-icon')),
      classPrefix: props.iconPrefix
    });
  };

  var renderPlaceholder = function renderPlaceholder() {
    if (status.loading && showLoading) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('loading')),
        onClick: props.onClick
      }, renderLoadingIcon());
    }

    if (status.error && showError) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('error')),
        onClick: props.onClick
      }, renderErrorIcon());
    }

    return null;
  };

  var renderImage = function renderImage() {
    if (status.error || !props.src) {
      return null;
    }

    var attrs = {
      className: clsx(bem('img')),
      style: {
        objectFit: fit
      }
    };
    return /*#__PURE__*/React.createElement("img", _extends({
      ref: imgRef,
      alt: props.alt || 'img',
      src: props.src,
      onLoad: onLoad,
      onError: onError
    }, attrs));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: clsx(props.className, bem({
      block: block,
      round: props.round
    })),
    style: style,
    onClick: props.onClick
  }, renderImage(), renderPlaceholder(), props.children);
};

export default Image;